import React from 'react';
import { NavLink as ReactRouterLink, NavLinkProps } from 'react-router-dom';

const Link = ({ to, ...props }: NavLinkProps) => (
  <ReactRouterLink
    to={to}
    style={{ textDecoration: 'none', color: 'inherit' }}
    {...props}
  />
);

export default Link;
